<template>
  <div class="pw-column" :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Column',
  props: {
    size: {
      type: [String, Number],
      default: '12',
    },
    align: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    classes() {
      return [`pw-column--size-${this.size}`, `pw-column--align-${this.align}`];
    },
  },
};
</script>

<style lang="scss" scoped>
.pw-column {
  padding-right: 8px;
  padding-left: 8px;
  min-height: 1px;
  box-sizing: border-box;
  &--align-right {
    text-align: right;
  }
  &--size-12 {
    width: 100%;
  }
  &--size-11 {
    width: 91.6666666%;
  }
  &--size-10 {
    width: 83.33333333%;
  }
  &--size-9 {
    width: 75%;
  }
  &--size-8 {
    width: 66.6666666%;
  }
  &--size-7 {
    width: 58.33333333%;
  }
  &--size-6 {
    width: 50%;
  }
  &--size-5 {
    width: 41.6666666%;
  }
  &--size-4 {
    width: 33.33333333%;
  }
  &--size-3 {
    width: 25%;
  }
  &--size-2 {
    width: 16.6666666%;
  }
  &--size-1 {
    width: 8.333333333%;
  }
}
</style>
